import { render, staticRenderFns } from "./paper_details.vue?vue&type=template&id=d1d1c1d0&"
import script from "./paper_details.vue?vue&type=script&lang=js&"
export * from "./paper_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports